import { Link, Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import { useLayoutEffect } from 'react';
import { Linkedin } from 'lucide-react';

export default function Layout() {
  const location = useLocation();
  
  const noHeaderPaths = [
    '/tools/decision-tree',
    '/tools/conversion-unlocker',
    '/find-your-edge',
    '/decision-tree',
    '/comparison',
    '/comparison/medallia',
    '/presentations/monday'
  ];

  const hideHeader = noHeaderPaths.includes(location.pathname);
  const isHomePage = location.pathname === '/';

  // Scroll to top on route change using useLayoutEffect
  useLayoutEffect(() => {
    const scrollOptions = {
      top: 0,
      behavior: 'smooth' as ScrollBehavior
    };

    // Ensure scroll happens before paint
    Promise.resolve().then(() => window.scrollTo(scrollOptions));
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      {!hideHeader && <Header isHomePage={isHomePage} />}

      <main className="flex-grow">
        <Outlet />
      </main>

      <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-4 max-w-6xl">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h4 className="font-semibold mb-4">Company</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="hover:text-blue-300">Home</Link></li>
                <li><Link to="/about" className="hover:text-blue-300">About Us</Link></li>
                <li>
                  <a 
                    href="https://www.linkedin.com/company/icpedge" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="hover:text-blue-300 inline-flex items-center gap-2"
                  >
                    <Linkedin className="w-5 h-5" /> LinkedIn
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Tools</h4>
              <ul className="space-y-2">
                <li><Link to="/find-your-edge" className="hover:text-blue-300">Find Your Edge</Link></li>
                <li><Link to="/tools/conversion-unlocker" className="hover:text-blue-300">Fix Conversion Blockers</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Comparison</h4>
              <ul className="space-y-2">
                <li><Link to="/comparison" className="hover:text-blue-300">ICP EDGE vs Qualtrics</Link></li>
                <li><Link to="/comparison/medallia" className="hover:text-blue-300">ICP EDGE vs Medallia</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Legal</h4>
              <ul className="space-y-2">
                <li><Link to="/privacy" className="hover:text-blue-300">Privacy Policy</Link></li>
                <li><Link to="/terms" className="hover:text-blue-300">Terms & Conditions</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-sm text-gray-400">
          2025 ICP EDGE. All rights reserved.
        </div>
      </footer>
    </div>
  );
}